import { z } from 'zod';
import { integration, shared, IntegrationConfiguration } from '@tig-dpqa-cloud/contract-backend-common';

export const DeploymentCredentials = shared.DataplaneManagementCredentials;

export type DeploymentCredentialsType = z.infer<typeof DeploymentCredentials>;

export const DeploymentIntegration = integration.TenantIntegrationConfiguration.extend({
  configuration: IntegrationConfiguration,
  roleURI: z.string(),
});

export type DeploymentIntegrationType = z.infer<typeof DeploymentIntegration>;
